const FALLBACK_SITE_URL = "https://sugargoosheet.wiki";

export function getSiteUrl(): string {
  try {
    const envUrl = (import.meta as Record<string, unknown>).env as Record<string, string> | undefined;
    if (envUrl?.VITE_SITE_URL) return envUrl.VITE_SITE_URL;
  } catch {
    // ignore
  }
  return FALLBACK_SITE_URL;
}

export const SEO_IMAGE_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg";

export function generateArticleJsonLd(params: {
  url: string;
  headline: string;
  description: string;
  datePublished?: string;
  dateModified?: string;
}): Record<string, unknown> {
  const siteUrl = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: params.headline,
    description: params.description,
    image: SEO_IMAGE_URL,
    author: {
      "@type": "Organization",
      name: "SugargooSpreadsheet.wiki",
      url: siteUrl,
    },
    publisher: {
      "@type": "Organization",
      name: "SugargooSpreadsheet.wiki",
      url: siteUrl,
      logo: {
        "@type": "ImageObject",
        url: SEO_IMAGE_URL,
      },
    },
    datePublished: params.datePublished || "2026-01-15",
    dateModified: params.dateModified || "2026-08-05",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": params.url,
    },
  };
}

export function generateWebSiteJsonLd(): Record<string, unknown> {
  const siteUrl = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Sugargoo Spreadsheet",
    url: siteUrl,
    description:
      "The ultimate Sugargoo Spreadsheet resource featuring organized product databases, expert reviews, shipping cost guides, warehouse information, coupons, and beginner tutorials for smarter international shopping.",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${siteUrl}/?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}

export function generateFAQJsonLd(
  faqs: { q: string; a: string }[]
): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };
}